define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/profiles/permissionsGridView.tmpl");
    var PermissionsGridRowView = require("user-management-views/profiles/PermissionsGridRowView");

    var PermissionsGridView = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        PermissionsGridView = Marionette.GridView.extend({
            className: "table-main ui-table",
            template: template,
            itemViewContainer: "tbody",
            itemView: PermissionsGridRowView,

            onCompositeCollectionRendered:function(){
                LEUserManagement.logger.debug("onCompositeCollectionRendered", "PermissionsGridView::onCompositeCollectionRendered");
            }
        });

    }

    LE.module("LEUserManagement", moduleDefinition);

    return PermissionsGridView;
});
